import { useAtom } from "@reatom/npm-react";
import { PaymentSubscribeRequestDto } from "definitions/poizon-bff";
import { Helmet } from "react-helmet";
import { FormProvider, useForm } from "react-hook-form";
import { appConfig } from "src/config";

import { useSubscribe } from "./hook/useSubscribe";
import { isOpenPromotionModalAtom } from "./store/atoms/promotionModalAtom";
import {
  BASE_SUBSCRIBES,
  subFormDefaultValues,
} from "./SubscribePage.constants";
import css from "./SubscribePage.module.scss";
import { calculateMaxRequests } from "./util";
import {
  SubscribeFormSection,
  SubscribeCard,
  ResponsivePromotionWidget,
} from "./widgets";

export const SubscribePage = () => {
  const form = useForm<PaymentSubscribeRequestDto>({
    defaultValues: subFormDefaultValues,
  });
  const { reset, watch } = form;
  const type = watch("type");

  const { price, isLoadingPrice } = useSubscribe(form);
  const [active, setActive] = useAtom(1);

  const [isOpenPromotion] = useAtom(isOpenPromotionModalAtom);

  return (
    <>
      <Helmet>
        <title>{appConfig.displayName} · Консоль · Подписки</title>
      </Helmet>
      <div className={css.subscribePageContainer}>
        <div className={css.subscribeSectionContainer}>
          <FormProvider {...form}>
            <section className={css.subscribeCardsSectionContainer}>
              <div className={css.subscribeCardsContainer}>
                {BASE_SUBSCRIBES.map((value, index) => {
                  return (
                    <SubscribeCard
                      type={type}
                      key={value.title}
                      {...value}
                      active={active === index}
                      onClick={() => {
                        setActive(index);
                        reset({
                          ...value.config,
                          type,
                          req: value.config.requests
                            ? value.config.requests
                            : calculateMaxRequests(value.config.rps),
                        });
                      }}
                    />
                  );
                })}
              </div>
            </section>
            <SubscribeFormSection
              price={price?.price || 0}
              isLoadingPrice={isLoadingPrice}
            />
          </FormProvider>
        </div>
      </div>
      {isOpenPromotion && <ResponsivePromotionWidget />}
    </>
  );
};
